import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDemand = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9 15H5.9c-.4 0-.696-.18-.888-.537-.191-.359-.17-.705.063-1.038l7.475-10.75c.167-.233.383-.396.65-.488.267-.091.542-.087.825.013.283.1.492.275.625.525s.183.517.15.8L14 10h3.875c.433 0 .738.192.913.575.174.383.12.742-.163 1.075L10.4 21.5a1.27 1.27 0 0 1-.675.425 1.133 1.133 0 0 1-.775-.075 1.31 1.31 0 0 1-.587-.538 1.232 1.232 0 0 1-.163-.787L9 15z",
		fill: "currentColor"
	})
});
export default SvgDemand;
